export const scrollToElement = (
  elementId: string,
  elementPosition: ScrollLogicalPosition,
  delay: number = 100
) => {
  setTimeout(() => {
    const element = document.getElementById(elementId);

    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: elementPosition,
      });
    }
  }, delay);
};

export const isOutOfViewport = (elementId: string) => {
  const element = document.getElementById(elementId);

  if (!element) {
    return false;
  }

  const rect = element.getBoundingClientRect();

  return (
    rect.top < 0 ||
    rect.left < 0 ||
    rect.bottom >
      (window.innerHeight || document.documentElement.clientHeight) ||
    rect.right > (window.innerWidth || document.documentElement.clientWidth)
  );
};
